import React, { useContext } from 'react'
import { Button } from 'react-angle-dashboard-components'
import { useHistory } from 'react-router-dom'
import { NavbarContext } from './NavbarContext'
import { Header } from './style'

export const Navbar = () => {
  const history = useHistory()

  const { backInfo } = useContext(NavbarContext)

  const handleBackBtn = () => {
    // added optional handleClick function to allow use of history.goBack()
    if (backInfo.handleClick) {
      backInfo.handleClick()
    } else if (backInfo.link.includes('https://')) {
      return window.location.assign(backInfo.link)
    } else {
      history.push(backInfo.link)
    }
  }

  return (
    <Header className="bg-primary">
      <Button
        onClick={handleBackBtn}
        variant="link"
        className="d-flex align-items-center text-white"
      >
        <i className="icon icon-left-arrow" />
        {backInfo.text}
      </Button>
    </Header>
  )
}
